/* 孫吳傳・第 9 章：丹徒遇刺（建安五年，200）
 * 史實：《三國志·孫策傳》「先是，策殺吳郡太守許貢，貢小子與客亡匿江邊。策單騎出，卒與客遇，客擊傷策。」
 *       臨終對孫權說：「舉江東之衆，決機於兩陳之間，與天下爭衡，卿不如我；舉賢任能，各盡其心，以保江東，我不如卿。」
 * 流程：孫策出獵，馬快，追著鹿群把護衛甩在後頭（追上鹿就算獵到）→ 江邊蘆葦叢裡衝出許貢的門客 →
 *       玩家可以反擊，但遇刺是劇情：一陣之後「客擊傷策」→ 護衛趕到 → 託孤的旁白卡，孫策篇結束。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, PEOPLE, rout } from '../kit.ts';

const CAMP = [900, 2500], LV = 10, HUNT_T = 60, DEER_N = 8;

export default {
  id: 'sunwu-9', map: 'dantu', hero: 'sunce',
  title: '第 8 章　丹徒遇刺', year: '建安五年（200）',
  brief: {
    quote: [{ text: '先是，策殺吳郡太守許貢，貢小子與客亡匿江邊。策單騎出，卒與客遇，客擊傷策。', src: '《三國志·吳書·孫策傳》' }],
    text: '孫策平定江東，正打算北上襲許。他喜歡出獵，所騎的是精駿的好馬，隨從常常跟不上。',
    goals: ['出獵：追上鹿群', '（遇刺是劇情，結局不會改變）'],
  },
  words: { ally: '護衛', foe: '門客' },
  stars: [
    { text: `${HUNT_T} 秒內獵到 5 隻鹿`, ok: (m) => m.vars.deer >= 5 },
    { text: '三名門客都親手擊殺', ok: (m) => m.vars.slain >= 3 },
    { text: '如史：單騎出獵（遇刺時護衛不在身邊）', ok: (m) => !!m.vars.alone },
  ],
  steps: [
    { // 1. 出獵
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 200; me.y = CAMP[1];
        w.addBuff(me, { id: '駿馬', t: 9999, ms: 0.35 });
        V.deer = 0; V.slain = 0; V.t0 = w.t;
        V.guards = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 3) * 50, me.y - 50 + Math.floor(i / 3) * 90, '護衛'); u.ms = 140; m.join(u, me); return u; });
        V.herd = Array.from({ length: DEER_N }, (_, i) => m.folk(2800 + (i % 4) * 260, 2000 + Math.floor(i / 4) * 700, { name: '鹿', still: true, near: 1, deer: true, draw: deer, ms: 0 }));
        m.line('孫策', '今日好天氣，出獵！誰追得上我的馬？');
        m.after(3, () => m.line('提示', '追上鹿就算獵到。孫策的馬快，護衛會落在後頭。'));
        m.obj('deer', `出獵：${HUNT_T} 秒內追上鹿群`, 5);
        m.mark('herd', 3200, 2400, '鹿群');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        m.unmark('herd');
        for (const d of V.herd) {
          if (d.got) continue;
          const dist = SG.gd(d.x, d.y, me.x, me.y);
          if (dist < 64) { d.got = true; d.x = -9999; V.deer++; m.prog('deer', V.deer); w.fx({ k: 'puff', x: me.x, y: me.y }); w.dmgEvents.push({ x: me.x, y: me.y - 80, text: `獵到第 ${V.deer} 隻`, team: 0, src: me.id, tgt: me.id }); continue; }
          // 鹿：人靠近 360 內就往反方向跑（比馬慢），跑不出獵場
          if (dist < 360) {
            const ax = d.x - me.x, ay = (d.y - me.y) / SG.K, L = Math.hypot(ax, ay) || 1, sp = 195 * dt;
            let nx = d.x + (ax / L) * sp, ny = d.y + (ay / L) * sp * SG.K;
            if (!SG.MAP.walkable(nx, ny, SG.MAP.BODY)) { nx = d.x + (-ay / L) * sp; ny = d.y + (ax / L) * sp * SG.K; }
            if (SG.MAP.walkable(nx, ny, SG.MAP.BODY) && nx > 1800 && nx < 4800) { d.f = nx < d.x ? -1 : 1; d.x = nx; d.y = ny; d.run = true; }
          } else d.run = false;
        }
        return w.t - V.t0 >= HUNT_T || V.deer >= DEER_N;
      },
    },
    { // 2. 卒與客遇
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('deer');
        // 刺客的致命一擊只會「擊傷」：留一口氣進劇情
        const pk = w.xPreKill;
        w.xPreKill = function (src, t) { if (t === me && m.i >= 1) { t.hp = 1; return true; } return pk.call(this, src, t); };
        V.alone = !V.guards.some((u) => u.alive && SG.gd(u.x, u.y, me.x, me.y) < 500);
        V.ke = [0, 1, 2].map((i) => {
          const a = (i / 3) * Math.PI * 2 + 0.6, u = boss(w, PEOPLE.kezi, me.x + Math.cos(a) * 320, me.y + Math.sin(a) * 220, { hp: 1400, atk: 44, armor: 4, ms: 300, name: '許貢門客', gold: 120, xp: 200 });
          u.target = me; return u;
        });
        m.big('有刺客！');
        m.card('策單騎出，卒與客遇。', '《孫策傳》');
        m.after(1.5, () => m.line('許貢門客', '我等是許貢的門客，今日替主人報仇！'));
        m.obj('ke', '擊退許貢的門客');
        V.ambushT = w.t;
        for (const u of V.guards) if (u.alive) u.ms = 230;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.slain = V.ke.filter((u) => !u.alive).length;
        return V.slain >= 3 || w.t - V.ambushT > 28 || me.hp < me.maxHp * 0.3; // 遇刺是劇情：打得再好也會被擊傷
      },
    },
    { // 3. 客擊傷策
      enter(m, w) {
        const me = w.player, V = m.vars;
        me.hp = Math.min(me.hp, me.maxHp * 0.15); me.st.stun = 1.5;
        w.fx({ k: 'spark', x: me.x, y: me.y - 40, col: '#ff4030' });
        m.big('客擊傷策');
        m.card('客擊傷策。', '《孫策傳》');
        rout(m, w, V.ke.filter((u) => u.alive), [6800, 2600]);
        V.ke.forEach((u) => { if (u.alive) u.untargetable = true; });
        m.drop('ke');
        for (const u of V.guards) if (u.alive) { const p = SG.MAP.nearestFree(me.x - 160 - SG.rand() * 80, me.y + (SG.rand() - 0.5) * 160); u.x = p[0]; u.y = p[1]; }
        m.after(2, () => m.line('護衛', '主公！主公！快護送主公回府！'));
        m.after(5, () => m.card('「舉江東之衆，決機於兩陳之間，與天下爭衡，卿不如我；舉賢任能，各盡其心，以保江東，我不如卿。」', '《孫策傳》（孫策臨終對孫權說）'));
        m.after(11, () => m.card('至夜卒，時年二十六。', '《孫策傳》'));
        m.after(15, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive && !m.vars.wounded) m.lose('孫策陣亡');
    if (m.i === 2) { m.vars.wounded = true; w.player.hp = Math.max(1, w.player.hp); }
  },
};

// 鹿：用馬的畫法，小一點、褐色；被追時跑
function deer(ctx, f, T) { if (f.got) return; SG.drawHorse(ctx, f.x, f.y, f.f || 1, f.run ? T * 1.4 : 0, '#a87a4a', '#6a4a2a', 0.7); }
